
import styled, { keyframes } from 'styled-components';
import { ThemeProps } from './globalStyles';

export const ButtonLoader = ({ loading, children }) => (
    <Button loading={loading} type='submit'>
       {loading?<LoadingSpinner loading={loading} />:
      <ButtonText loading={loading}>
        {children}
      </ButtonText>} 
      
    </Button>
  );

  const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
}`

  const Button = styled.button.attrs(({ type = 'button' }) => ({ type }))`
  background-color: ${ThemeProps.color.gabaYellow};
  border-radius: 6px;
  height: 48px;
  color: ${ThemeProps.color.darkBlue};
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  width: 48%;
  border: none;
`

const LoadingSpinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  border-top-color: white;
  opacity: ${({ loading }) => loading ? 1 : 0};
  
  margin: auto;
  width: 20px;
  height: 20px;
  transition: opacity 5ms;
  animation: ${rotate} 1s linear;
  animation-iteration-count: infinite;
  transition-delay: ${({ loading }) => loading ? '15ms' : '0ms'}
  `
  const ButtonText = styled.p`
  
  transition: opacity 200ms;
  transition-delay: ${({ loading }) => loading ? '0ms' : '15ms'};
  width: 100%;
  opacity: ${({ loading }) => loading ? 0 : 1};`

  